import useCallApi from '../../utilities/axios'
import { encryption } from '../../utilities/encryption'
import * as umServiceURL from './umServiceURL'

export type FormType = {
    userID?: string
    email: string
    password: string
}
const useActivate = () => {
    const callApi = useCallApi()

    const postActivate = async (userID: number, password: string) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServiceURL.postActivate,
            params: { userID, password: encryption(password) },
        })

        return data
    }

    const postActivateOTP = async (userID: number, token: string) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServiceURL.postActivateOTP,
            params: { userID, token },
        })

        return data
    }
    return { postActivate, postActivateOTP }
}

export default useActivate
